import React, { useState } from "react";
import styles from "./Functions.module.scss";
import {
  FormControl,
  Grow,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import CustomStatusDropdown from "../../containers/TcsGigDB/Functions/CustomStatusDropdown";

const useStyles = makeStyles((theme) => ({
  MuiFormControlRoot: {
    verticalAlign: "baseline",
  },
  actionDropdown: {
    "& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-hover .MuiOutlinedInput-notchedOutline":
    {
      border: "1px solid #1C4980",
    },
    "& .MuiOutlinedInput-root, .MuiSelect-icon": {
      color: "#1C4980",
    },
    "& .MuiInputBase-root.Mui-disabled, .MuiSelect-icon.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #cccccc",
    },
  },
}));

const ActionsDropdown = (props) => {
  const {
    uniqueKey,
    actions,
    handleActions,
    actionList,
    isRowSelected,
    disableOption,
    dropdownName,
    searchList,
    selectedStatusOption,
    selectedOption,
    selectedAssignIds,
    updateMyData,
    toggleStatusUpdated,
    setToggleStatusUpdated,
    sortStatusOrder,
  } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    setOpen(!open);
  };

  return (
    <FormControl
      variant="outlined"
      disabled={uniqueKey === "actionTcs" ? false : isRowSelected}
      classes={{ root: classes.MuiFormControlRoot }}
      className={`${classes.actionDropdown} ${styles.actionFormControl}`}
    >
      <Select
        id="actions"
        value={actions}
        classes={{ outlined: styles.actionSelect }}
        onChange={handleActions}
        open={open}
        onClose={handleClose}
        onOpen={() => setOpen(true)}
        MenuProps={{
          disablePortal: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: uniqueKey === "actionWorker" ? "left" : "right",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: uniqueKey === "actionWorker" ? "left" : "right",
          },
          getContentAnchorEl: null,
          disableAutoFocusItem: true,
          keepMounted: true,
          TransitionComponent: Grow,
        }}
      >
        <MenuItem value={-1} disabled={true}>
          {dropdownName}
        </MenuItem>
        {actionList.map((item, id) => {
          if (item.value) {
            return (
              <MenuItem
                key={id}
                value={item.value}
                onClick={(e) => {
                  if (
                    uniqueKey === "actionTcs" &&
                    item.value === "updateStatus"
                  ) {
                    e.stopPropagation(); // Stop menu from closing
                    setOpen(true); // Keep it open
                  } else {
                    setOpen(false); // Close on other selections
                  }
                }}
                disabled={
                  uniqueKey === "actionWorker" && item.value === "agreement"
                    ? disableOption
                    : uniqueKey === "actionTcs" && item.value === "blacklist"
                      ? isRowSelected || selectedStatusOption.id === "33"
                      : uniqueKey === "actionTcs" && item.value === "backedOut"
                        ? isRowSelected
                        : uniqueKey === "actionTcs" && item.value === "updateData"
                          ? selectedOption.id === "active" ||
                          selectedOption.id === "inactive" ||
                          selectedStatusOption.id !== "36"
                          : false
                }
              >
                {uniqueKey === "actionTcs" && item.value === "updateStatus" ? (
                  <CustomStatusDropdown
                    disabled={
                      isRowSelected
                        ? true
                        : selectedStatusOption.id !== "7" &&
                        selectedStatusOption.id !== "28" &&
                        selectedStatusOption.id !== "30" &&
                        selectedStatusOption.id !== "32"
                    }
                    searchList={searchList}
                    assignIds={selectedAssignIds}
                    dropdownName={item.label}
                    buttonName="Update"
                    toggleStatusUpdated={toggleStatusUpdated}
                    setToggleStatusUpdated={setToggleStatusUpdated}
                    uniqueKey="updateStatusTcs"
                    updateMyData={updateMyData}
                    fileName="Invalid lead data"
                    selectedStatusOption={selectedStatusOption}
                    sortStatusOrder={sortStatusOrder}
                  />
                ) : (
                  item.label
                )}
              </MenuItem>
            );
          }
          return;
        })}
      </Select>
    </FormControl>
  );
};

export default ActionsDropdown;
